module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0050_id_approval_history")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-search', {
    attrs: {
      "title": "ID申請履歴"
    }
  }), _vm._v(" "), _c('search-control', {
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "field_names": _vm.allSearchFields
    },
    on: {
      "change": _vm.searchControlChangedDatasource
    }
  }), _vm._v(" "), _c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "325px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.bulkApprovalStage4
    }
  }, [_vm._v("申請クリア")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "10px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    attrs: {
      "disabled": _vm.disablePageApprove
    },
    on: {
      "click": _vm.bulkApprovalStage1
    }
  }, [_vm._v("承認")])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage2ConfirmatioModal"
    },
    on: {
      "done": _vm.bulkApprovalStage3
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402fb5d8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0050_id_approval_history.vue
// module id = 968
// module chunks = 0